import { useLang } from "@/context/LanguageContext";
import { Check } from "lucide-react";

export function ChipList({ label, options, selected, onToggle, idKey, testid, badge }) {
  const { t } = useLang();
  return (
    <div>
      <div className="mb-2 text-xs font-bold uppercase tracking-[0.15em] text-zinc-500">{label}</div>
      <div className="flex flex-wrap gap-2">
        {options.length === 0 && <span className="text-sm text-zinc-400">{t("onb.noneAvailable")}</span>}
        {options.map((o) => {
          const id = o[idKey];
          const on = selected.includes(id);
          return (
            <button key={id} type="button" onClick={() => onToggle(id)} data-testid={`${testid}-${id}`}
              className={`flex items-center gap-1.5 border px-3 py-1.5 text-sm transition-colors ${on ? "border-primary bg-primary text-white" : "border-zinc-300 bg-white text-zinc-600 hover:border-zinc-400"}`}>
              {on && <Check size={14} />} {o.displayName}
              {badge && badge(o, on)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
